import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { AdminGuard, AdminNav } from "../components/admin/AdminShell";
import { StatusBadge } from "../components/product/StatusBadge";

const TIER_COLORS = {
  "Emerging Account": "border-slate-500/40 text-brand-text bg-slate-500/5",
  "Growth Account": "border-brand-navy text-brand-accent bg-brand-surface",
  "Enterprise Account": "border-emerald-500/40 text-emerald-300 bg-emerald-500/5",
};

export default function AdminWholesaleLeads() {
  const [leads, setLeads] = useState([]);

  useEffect(() => {
    api.get("/admin/wholesale-leads").then((r) => setLeads(r.data)).catch(() => {});
  }, []);

  return (
    <AdminGuard>
      <AdminNav />
      <div className="max-w-7xl mx-auto px-4 py-10" data-testid="admin-wholesale-leads-page">
        <div className="mb-6">
          <div className="overline mb-2">Wholesale</div>
          <h1 className="font-display text-3xl md:text-4xl font-semibold tracking-tight text-brand-navy">Wholesale Leads</h1>
          <p className="mt-2 text-brand-muted text-sm max-w-2xl">Nonbinding purchasing-volume inquiries. Follow up with a per-account proposal only after verification and product-level review.</p>
        </div>

        {leads.length === 0 ? (
          <div className="border border-brand-border bg-white p-16 text-center">
            <div className="font-display text-xl text-brand-navy">No leads yet.</div>
          </div>
        ) : (
          <div className="border border-brand-border divide-y divide-brand-border">
            {leads.map((l) => (
              <div key={l.id} className="p-6 bg-white grid grid-cols-12 gap-4 items-center">
                <div className="col-span-3">
                  <div className="font-display text-brand-navy">{l.company}</div>
                  <div className="text-xs text-brand-muted font-mono">{l.name} · {l.email}</div>
                </div>
                <div className="col-span-3 text-xs text-brand-muted font-mono">
                  Volume: {l.estimated_monthly_units}<br/>
                  Budget: {l.estimated_monthly_budget || "—"}
                </div>
                <div className="col-span-3 text-xs text-brand-muted font-mono">
                  {l.organization_type}<br/>
                  {l.state || "—"}
                </div>
                <div className="col-span-2">
                  <span className={`inline-flex items-center px-2 py-0.5 text-[10px] font-mono uppercase tracking-wider border ${TIER_COLORS[l.qualification_tier] || TIER_COLORS["Emerging Account"]}`}>
                    {l.qualification_tier}
                  </span>
                </div>
                <div className="col-span-1 text-right">
                  <StatusBadge status={l.status} kind="compliance" />
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </AdminGuard>
  );
}
